import getIntl from 'Helpers/intl'

import { STORE_KEY_ID_LIST, storeGet } from 'mailup-react-helpers'

import {
  beRecipientApiSegmentRecipientByCustomSearch,
  beRecipientApiSimulateSegmentRecipientGroupName,
} from 'Api/beRecipientApiTS'
import type { ModalAddSegmentState } from 'Pages/RecipientsList/model'

import {
  searchFiltersToConditions,
  toSubscriptionStatus,
} from 'Pages/RecipientsList/recoil/services/results'

export const isGroupNameAvailable = async (
  name: string | null,
): Promise<boolean> => {
  if (name === null || name.length === 0) return true

  const idList: number = storeGet(STORE_KEY_ID_LIST)

  const { Available } = await beRecipientApiSimulateSegmentRecipientGroupName(
    idList,
    { Prefix: name },
  )
  return Available
}

export const getSegmentDefaults = async (): Promise<{
  name: string
  nameConflict: boolean
}> => {
  const Prefix = getIntl().formatMessage({
    id: 'Load.RecipientsList.SegmentDefaultName',
  })

  const available = await isGroupNameAvailable(Prefix)

  return {
    name: Prefix,
    nameConflict: !available,
  }
}

export const segmentRecipients = async ({
  name,
  maxRecipientsInGroup,
  distMode,
  searchCrit,
}: Pick<
  ModalAddSegmentState,
  'name' | 'maxRecipientsInGroup' | 'distMode' | 'searchCrit'
>): Promise<void> => {
  if (name !== null && maxRecipientsInGroup !== null) {
    const idList: number = storeGet(STORE_KEY_ID_LIST)

    const Conditions = searchFiltersToConditions(searchCrit)
    const SubscriptionStatus = toSubscriptionStatus(searchCrit.status.value)

    await beRecipientApiSegmentRecipientByCustomSearch(idList, {
      Conditions,
      SubscriptionStatus,
      RecipientIds: [],
      //
      Prefix: name,
      MaxRecipientsInGroup: maxRecipientsInGroup,
      SegmentationType: distMode,
    })
  }
}
